import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles, styled } from "@material-ui/core/styles";
import { Chip, colors } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    chip: {
        paddingLeft: "10px",
        paddingRight: "10px",
        marginLeft: "10px",
    },
}));
export const restType = [
    { id: 1, name: "local", label: "محلي " },
    { id: 2, name: "Out", label: "سفري" },
    { id: 5, name: "Delivery", label: "توصيل" },

];
const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
}));

const OntherFilter = (props) => {
    const { changeOrderType, orderData } = props;
    const classes = useStyles();
    const { t } = useTranslation(["forms"]);

    return (
        <>
            <Container
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    listStyle: "none",
                    padding: "2px",
                    margin: "0px",
                }}
                component="ul"
            >
                {restType.map((x) => {
                    return (
                        <ListItem key={x.id}>
                            {x.id === orderData.select.id ? (
                                <Chip
                                    className={classes.chip}
                                    label={t(x.label)}
                                    icon={<Done />}
                                    style={{
                                        backgroundColor: colors.green[300],
                                        color: "#fff",fontWeight:"bold",fontSize:"0.9rem"
                                    }}
                                    clickable
                                />
                            ) :
                                (
                                    <Chip
                                        className={classes.chip}
                                        label={t(x.label)}
                                        variant="outlined"
                                        color={"green"}
                                        style={{fontWeight:"bold",fontSize:"0.9rem"}}
                                        onClick={() => {
                                            changeOrderType(x);
                                        }}
                                    />
                                )}
                        </ListItem>
                    );
                })}
            </Container>
        </>

    );
};

export default OntherFilter;
